import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {FilterHeaderService} from '../../services/filter-header.service';

@Component({
  selector: 'app-load-filters-dialog',
  templateUrl: './load-filters-dialog.component.html',
  styleUrls: ['./load-filters-dialog.component.css']
})
export class LoadFiltersDialogComponent implements OnInit {

  filterList = [];
  selectedFilter: string;

  constructor(
    public dialogRef: MatDialogRef<LoadFiltersDialogComponent>,
    private filterHeaderService: FilterHeaderService
  ) {
  }

  ngOnInit() {
    this.filterHeaderService.loadFilterNames()
      .subscribe(result => {
        JSON.parse(result['filter_names']).forEach(r => {
          this.filterList.push(r[0]);
        });
      });
  }

  loadFilters() {
    this.filterHeaderService.loadChoices(this.selectedFilter)
      .subscribe(result => {
        this.dialogRef.close({
          filterName: this.selectedFilter,
          filters: result['filters']
        });
      });
  }

  onItemSelected(selectedFilter) {
    this.selectedFilter = selectedFilter;
  }

  onDeleteClicked(selectedFilter) {
    this.filterHeaderService.deleteChoice(selectedFilter)
      .subscribe(result => {
        console.log(result);

        if (this.selectedFilter === selectedFilter) {
          this.selectedFilter = undefined;
        }

        this.filterList.splice(this.filterList.indexOf(selectedFilter), 1);
      });
  }
}
